import { useLocalStorage } from '@mantine/hooks';
import { usePermissions } from '@sportybot-web/auth/permissions/use-permissions';
import { useAuth } from '@sportybot-web/auth/useAuth';
import { useMemo } from 'react';

import { AppMode, AppModeContext, DEFAULT_APP_MODE, getAppModeStorageKey } from './context';

export function AppModeProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const { can } = usePermissions();

  const canSwitchAppMode = can('CAN_SWITCH_APP_MODE');

  // `getInitialValueInEffect: false` reads storage on the first render (no flash).
  const [storedAppMode = DEFAULT_APP_MODE, setStoredAppMode] = useLocalStorage<AppMode>({
    getInitialValueInEffect: false,
    key: getAppModeStorageKey(user.id),
  });

  // Permissions are the source of truth: MiLB-only users are always MiLB, and a stored value is
  // only honoured for users who are allowed to switch.
  const appMode = canSwitchAppMode ? storedAppMode : AppMode.MILB;

  const value = useMemo(
    () => ({ appMode, setAppMode: setStoredAppMode }),
    [appMode, setStoredAppMode],
  );

  return <AppModeContext value={value}>{children}</AppModeContext>;
}
